<template>
  <div style="display: flex; flex-direction: column;height: 100%">
    <div class="sub-title"><i class="iconfont icon-shuju"></i> 人脸库列表</div>
    <div class="main-shadow-box">
      <el-row style="margin-bottom: 10px;">
        <el-button @click="addVisible = true"
                   style="float: right" type="primary">新增</el-button>
      </el-row>
      <el-table :data="list" size="medium">
        <el-table-column prop="name" label="人脸库名称"></el-table-column>
        <el-table-column prop="owner" label="创建人">
          <template v-slot="s">{{s.row.owner | user_name}}</template>
        </el-table-column>
        <el-table-column prop="size" label="规模">
          <template v-slot="s">{{ s.row.size }}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间">
          <template v-slot="s">{{s.row.createTime | date}}</template>
        </el-table-column>
        <el-table-column prop="expired" label="剩余有效期">
          <template v-slot="s">{{s.row.expired | expired}}</template>
        </el-table-column>
        <el-table-column label="操作" align="center"  width="240">
          <template v-slot="s">
            <el-button @click="openMain(s.row.id)">操作</el-button>
            <el-button @click="openUpdate(s.row.id)">修改</el-button>
            <el-button @click="openCompare(s.row.id)" type="primary">1vN对比</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <main-dialog :visible.sync="mainVisible" :bucket-id="currentBucketId"
                 ></main-dialog>
    <update-dialog :visible.sync="updateVisible" :bucket-id="currentBucketId"></update-dialog>
    <add-dialog :visible.sync="addVisible"></add-dialog>
    <compare-dialog :visible.sync="compareVisible" :bucket-id="currentBucketId"></compare-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import updateDialog from './update'
import addDialog from './add'
import mainDialog from './main'
import compareDialog from './compare'

export default {
  components: {
    updateDialog,
    addDialog,
    mainDialog,
    compareDialog
  },
  data() {
    return {
      addVisible: false,
      updateVisible: false,
      mainVisible: false,
      compareVisible: false,
      currentBucketId: null
    };
  },
  async beforeRouteEnter(to, from, next) {
    if(Vue.store.state.me === null) {
      next(vm => {
        vm.$router.push('login')
      })
    } else {
      await Vue.store.dispatch("bucket/list");
      next();
    }
  },
  computed: {
    ...mapState("bucket", ["list"])
  },
  methods: {
    openUpdate(id){
      this.currentBucketId = id;
      this.updateVisible = true;
    },
    openMain(id){
      this.currentBucketId = id;
      this.mainVisible = true;
    },
    openCompare(id){
      this.currentBucketId = id;
      this.compareVisible  = true;
    }
  },
};
</script>
